import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EditorBookingItem } from './editor-booking-item.model';
import { EditorBookingItemEditStore } from '../editor-booking-item-edit/editor-booking-item-edit.store';
import { EditorBookingItemExportDialogComponent } from '../editor-booking-item-export-dialog/editor-booking-item-export-dialog.component';
import { EditorBookingItemTreeStore } from '../editor-booking-item-tree/editor-booking-item-tree.store';
import { EditorBookingItemTreeDataEditStore } from '../editor-booking-item-tree-data-edit/editor-booking-item-tree-data-edit.store';
import { EditorDialogStore } from '../editor-dialog/editor-dialog.store';


@Component({
    selector: 'eas-editor-booking-item',
    templateUrl: './editor-booking-item.component.html',
    styleUrls: ['./editor-booking-item.component.css'],
    standalone: false
})
export class EditorBookingItemComponent implements OnInit, OnDestroy {
  private destroyed$ = new Subject<void>();

  item: EditorBookingItem;
  itemOptions: EditorBookingItem[];
  editingItem: EditorBookingItem;

  constructor(
    private dialog: MatDialog,
    private itemTreeStore: EditorBookingItemTreeStore,
    private itemTreeDataEditStore: EditorBookingItemTreeDataEditStore,
    private itemEditStore: EditorBookingItemEditStore,
    private itemDialogStore: EditorDialogStore
  ) {

  }

  ngOnInit() {
    this.itemTreeStore.rootItem$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(item => this.item = item);

    this.itemTreeStore.itemOptions$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(itemOptions => this.itemOptions = itemOptions);

    this.itemTreeStore.editingItem$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(editingItem => this.editingItem = editingItem);
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  onAddItem() {
    this.itemTreeStore.addItem(this.item.id);
    return false;
  }

  onToggleShowSettings() {
    this.itemTreeStore.setShowSettings(this.item.id, !this.item.showSettings);
    return false;
  }

  onEdit() {
    this.itemTreeDataEditStore.startEditing(null);
    this.itemEditStore.startEditing(this.item.id, { name: 'allButName', value: null });
    this.itemDialogStore.editBookingItemRoot();
    return false;
  }

  onAddChild() {
    this.itemTreeStore.addItem(this.item.id);
    return false;
  }

  onEditNameList() {
    this.itemTreeStore.startEditingNameList(this.item.id);
    return false;
  }

  onExport() {
    this.dialog.open(EditorBookingItemExportDialogComponent, {
      closeOnNavigation: true,
      disableClose: true,
      hasBackdrop: true,
      minWidth: '50vw',
      id: 'booking-item-editor-export-dialog',
      data: { bookingItem: this.itemTreeStore.getBookingItemFromItemTree() }
    });
    return false;
  }

  getBookableBadgeTitle() {
    return this.item.userCanBook() ? $localize `Bookable` : $localize `Not bookable`;
  }

  getBookableBadgeVariant() {
    return this.item.userCanBook() ? 'success' : 'none';
  }

  getSettingsButtonTitle() {
    return this.item.showSettings ? $localize `Hide settings` : $localize `Show settings`;
  }
}
